// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'

import { checkGotoChooseAccount } from '../../../utils/common-utils'

import ExternalSCIMPage from './ExternalSCIMPage'
import ExternalSCIMDetailsPage from './components/ExternalSCIMDetailsPage'

const ExternalSCIMRouter = () => {
  const navigate = useNavigate()
  const location = useLocation()
  checkGotoChooseAccount(navigate, location)

  return (
    <Routes>
      <Route exact path="/" element={<ExternalSCIMPage />} />
      <Route path="/:id" element={<ExternalSCIMDetailsPage />} />
    </Routes>
  )
}

export default ExternalSCIMRouter
